module.exports = __webpack_public_path__ + "media/images/dark-ghost-loading-1a08d78775cea1a15cfb391a03e18488.gif";